<template>
	<div class="mb-4">
		<Error401></Error401>
	</div>
</template>

<script>
import Error401 from '@/components/Widgets/Errors/Error401.vue';
export default {
	name: '401',
	components: {
    Error401,
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
